export default [
  {
    name: 'empathetic',
    image_url: '/img/emoji/empathetic.svg',
    odd: false,
  },
  {
    name: 'enthusiastic',
    image_url: '/img/emoji/enthusiastic.svg',
    odd: true,
  },
  {
    name: 'persevering',
    image_url: '/img/emoji/persevering.svg',
    odd: false,
  },
  {
    name: 'a team player',
    image_url: '/img/emoji/team-player.svg',
    odd: true,
  },
];
